import Vue from 'vue';
import Router from 'vue-router';

// 登录
const login = () => import('@/components/login');

// 入口页
const appIndex = () => import('@/components/index.vue');
// 首页
const homeIndex = () => import('@/components/home/index.vue');

// 访客管理
const visitorManage = () => import('@/components/visitor');
const visitorMessage = () => import('@/components/visitor/visitorMessage.vue'); // 访客信息
const succRecord = () => import('@/components/visitor/succRecord.vue'); // 入校成功记录()
const errRecord = () => import('@/components/visitor/errRecord.vue'); // 入校失败记录()

// 入校审批
const enteringApproval = () => import('@/components/entering');
const toDo = () => import('@/components/entering/toDo.vue'); // 待办事宜
const approvalRecord = () => import('@/components/entering/approvalRecord.vue'); // 审批记录

// 填报管理
const fillManage = () => import('@/components/fill');
const fillMessage = () => import('@/components/fill/fillMessage.vue'); // 填报信息
const addFill = () => import('@/components/fill/addFill.vue'); // 新增填报信息

// 系统设置
const systemSetting = () => import('@/components/systemSetting');
const committeeManage = () => import('@/components/systemSetting/committeeManage'); // 校委管理
const organizeManage = () => import('@/components/systemSetting/organizeManage'); // 用户管理
const approvalManage = () => import('@/components/systemSetting/approvalManage'); // 审批管理
const teamManage = () => import('@/components/systemSetting/teamManage'); // 班组管理
const formManage = () => import('@/components/systemSetting/formManage'); // 填报表单管理
const deviceManage = () => import('@/components/systemSetting/deviceManage'); // 手持设备管理
const instructions = () => import('@/components/systemSetting/instructions'); // 使用说明

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '*',
      redirect: '/app/home'
    },
    {
      path: '/app',
      name: 'appIndex',
      component: appIndex,
      children: [
        {
          path: 'home',
          name: 'homeIndex',
          component: homeIndex
        },
        {
          path: 'system',
          name: 'systemSetting',
          component: systemSetting,
          children: [
            {
              path: 'committee',
              name: 'committeeManage',
              component: committeeManage
            },
            {
              path: 'organize',
              name: 'organizeManage',
              component: organizeManage
            },
            {
              path: 'approvalM',
              name: 'approvalManage',
              component: approvalManage
            },
            {
              path: 'team',
              name: 'teamManage',
              component: teamManage
            },
            {
              path: 'form',
              name: 'formManage',
              component: formManage
            },
            {
              path: 'device',
              name: 'deviceManage',
              component: deviceManage
            },
            {
              path: 'instructions',
              name: 'instructions',
              component: instructions
            }
          ]
        },
        {
          path: 'visitor',
          name: 'visitorManage',
          component: visitorManage,
          children: [
            {
              path: 'visitorMe',
              name: 'visitorMessage',
              component: visitorMessage
            },
            {
              path: 'succRecord',
              name: 'succRecord',
              component: succRecord
            },
            {
              path: 'errRecord',
              name: 'errRecord',
              component: errRecord
            }
          ]
        },
        {
          path: 'fill',
          name: 'fillManage',
          component: fillManage,
          children: [
            {
              path: 'fillMe',
              name: 'fillMessage',
              component: fillMessage
            },
            {
              path: 'add',
              name: 'addFill',
              component: addFill
            }
          ]
        },
        {
          path: 'entering',
          name: 'enteringApproval',
          component: enteringApproval,
          children: [
            {
              path: 'toDo',
              name: 'toDo',
              component: toDo
            },
            {
              path: 'approval',
              name: 'approvalRecord',
              component: approvalRecord
            }
          ]
        }
      ]
    },
    {
      path: '*',
      name: 'frame',
      component: appIndex
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js